import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { translate } from './localisation/localisation';
import { CASE } from './constants';

import Loader from 'components/Loader';
import AppRouter from './router';

export const TranslateContext = React.createContext();

const App = () => {
  const { isLoading, languageCode } = useSelector((state) => state);
    const [language, setLanguage] = useState(' ');
  
  useEffect(() => {
      const initLanguage = () => {
          const params = new URLSearchParams(window.location.search);
          const urlLanguage = params.get('language');
          const storedLanguage = sessionStorage.getItem('language');

          const languageToSet = urlLanguage || storedLanguage || 'en-GB';

          setLanguage(languageToSet);
          sessionStorage.setItem('language', languageToSet);
      };

      initLanguage();
  }, []);

  return (
    <TranslateContext.Provider value={{language}}>
      <Router basename={process.env.REACT_APP_BASENAME}>
        <Suspense fallback={<Loader />}>
          <AppRouter />
          {isLoading && <Loader />}
        </Suspense>
      </Router>
    </TranslateContext.Provider>
    
  );
};

export default App;
